<script lang="ts">
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  import Tags from "./SvelteTagsInput.svelte";
  import * as _ from "lodash";
  export let apiHandler;
  export let value = null; //initial data
  export let dropdownItemTemplateCB;
  export let dropdownItemTemplateComponent;
  export let placeholder = "";
  export let disabled = false;
  export let addFromAutocompleteOnly;
  export let inputId;
  export let inputErrors;
  export let minInputCharLengthForApiRequest = 2;
  export let displayTags = true;
  export let dropdownClassName = "";
  export let preSelectedOptions = [];
  export let autoCompleteKey = "name";
  export let clickedIntoInput: boolean = null;
  export let leftInput: boolean = null;

  let submitting = true;
  let tags = [];

  function handleTags(event) {
    tags = _.uniqBy(event.detail.tags, function (x) {
      return x.id || x.contact_email;
    });
    value = tags;
    dispatch("change");
  }

  function prepListData(dataList) {
    return _.uniqBy(
      _.map(dataList, function (x) {
        return _.merge(x, { editable: false });
      }),
      function (x) {
        return x.id || x.contact_email;
      }
    );
  }

  const customAutocomplete = async inputValue => {
    if (preSelectedOptions.length) {
      return prepListData(preSelectedOptions);
    } else if (inputValue.length >= minInputCharLengthForApiRequest) {
      submitting = true;
      const res = await apiHandler(inputValue).finally(response => {
        submitting = false;
      });
      return prepListData(res.data);
    } else {
      return [];
    }
  };

  if (value && value.length) {
    tags = prepListData(value);
  }

  const forwardEvent = e => {
    dispatch(e.type, e.detail);
  };

  $: {
    value = value;
    if (value && value.length && displayTags == true) {
      tags = prepListData(value);
    } else {
      tags = [];
    }
    preSelectedOptions = preSelectedOptions;
  }

  $: {
    submitting = submitting;
  }

</script>

<Tags
  {dropdownClassName}
  {dropdownItemTemplateCB}
  {dropdownItemTemplateComponent}
  {addFromAutocompleteOnly}
  {submitting}
  id={inputId}
  bind:disable={disabled}
  on:tags={handleTags}
  on:focus={forwardEvent}
  on:tagAdded={forwardEvent}
  on:tagRemoved={forwardEvent}
  on:keyenter={forwardEvent}
  autoComplete={customAutocomplete}
  {autoCompleteKey}
  onlyUnique={true}
  removeKeys={[27, 8]}
  {placeholder}
  allowBlur={true}
  minChars={1}
  {tags}
  {inputErrors}
  bind:clickedIntoInput
  bind:leftInput
>
  <slot slot="dropdown-header" name="dropdown-header" />
  <slot slot="dropdown-footer" name="dropdown-footer" />
</Tags>
